import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeAtSign',
})
export class RemoveAtSignPipe implements PipeTransform {
  public transform(value: string): string {
    if (!value) {
      return value;
    }

    return value.replaceAll('@', '');
  }
}
